export enum Status {
    ToDo = 1,
    InProgress = 2,
    Done = 3,
}

export enum LogActions {
    ThemCongViec = 1,
    CapNhatTrangThaiCongViec = 2,
    CapNhatTienDo = 3,
    XoaCongViec = 4,
    HoanThanhCongViec = 5,
    CapNhatNguoiDuocGiao = 6,
    XoaNguoiDuocGiao = 7,
}
